import { Component, OnInit } from "@angular/core";
import { NgForm, ReactiveFormsModule, FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { ApiService } from "../services/api.service";
import { ErrorDialogComponent } from "../error-dialog/error-dialog.component";
import { MatDialog } from "@angular/material/dialog";

import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatInput } from "@angular/material/input";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatCard, MatCardHeader, MatCardImage, MatCardContent } from "@angular/material/card";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "cim-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    standalone: true,
    imports: [
    MatCard,
    MatCardHeader,
    MatCardImage,
    ReactiveFormsModule,
    FormsModule,
    MatCardContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatSuffix,
    MatButton
],
})
export class LoginComponent implements OnInit {
  invalidLogin: boolean;
  error: "";
  base: string;
  site: string;
  user: string;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private apiService: ApiService,
    public dialogBox: MatDialog
  ) {}

  ngOnInit() {
    this.authenticationService.logout();
    this.apiService.initSettings().subscribe((infos) => {
      this.apiService.appSettings = infos;
      this.base = this.apiService.appSettings.Base;
      this.site = this.apiService.appSettings.Site;
      this.user = this.apiService.appSettings.User;
    });
  }

  login(form: NgForm) {
    if (form.valid) {
      //const credentials = JSON.stringify(loginmodel);
      var loginmodel = form.value;
      loginmodel["NomApplication"] = "CalcCharges";
      const credentials = JSON.stringify(loginmodel);
      this.authenticationService.login(credentials).subscribe(
        (response) => {
          this.invalidLogin = false;
          // this.router.navigate(["gantt"]);
          this.router.navigate(["gantt"]).then(() => {
            /** Obligé de tout recharger sinon le menu contextuel de marche plus */
            window.location.reload();
          });
        },
        (err) => {
          this.invalidLogin = true;
          if (
            err.error === "PASSWORD_FAILED" ||
            err.error === "USER_FAILED" ||
            err.error === "SITE_FAILED"
          ) {
            this.openDialog(err);
          }
        }
      );
    }
  }
  openDialog(err): void {
    const data = { title: "Invalid login", error: err.error };
    const dialogRef = this.dialogBox.open(ErrorDialogComponent, {
      width: "400px",
      data,
    });
  }
}
